import React from "react";
import "./Services.css";
import { motion } from "framer-motion";
import ThreeDCard from "./ThreeDCard";

const services = [
  {
    title: "Custom Websites",
    description: "At Kura we provide a fully dedicated, personalised experience in designing and developing responsive, user-friendly websites tailored to your business needs.",
    imageSrc: "/assets/card-website.png",
  },
  {
    title: "Software Development",
    description: "We build custom software solutions and new features on top of existing software, across different technologies with best practices in mind.",
    imageSrc: "/assets/card-software.png",
  },
  {
    title: "Support and Security",
    description: "Kura provides you with a full aftercare experience and ongoing support, ensuring your website or software is secure and up-to-date.",
    imageSrc: "/assets/card-support.png",
  },
];

const Services = () => {
  return (
    <section id="services" className="pb-12"> {/* ✅ Removed mb-12 to prevent extra spacing */}
      <h2 className="text-4xl font-bold mb-12 text-center dark:text-white">Services</h2>
      <motion.div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 justify-center"
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 0, y: 20 },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              delay: 0.3,
              duration: 0.5,
              staggerChildren: 0.3,
            },
          },
        }}
      >
        {services.map((service, index) => (
          <motion.div
            key={index}
            className="flex justify-center"
            whileHover={{ scale: 1.05 }}
          >
            <ThreeDCard
              title={service.title}
              description={service.description}
              imageSrc={service.imageSrc}
            />
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default Services;
